import React, { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext({ theme: "b", setTheme: () => {} });

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(() => {
    return localStorage.getItem("mashva-theme") || "b";
  });

  const setTheme = (t) => {
    setThemeState(t);
    localStorage.setItem("mashva-theme", t);
    // Update body attribute for global dark mode styles
    document.body.dataset.theme = t;
  };

  // Apply body attribute on mount
  useEffect(() => {
    document.body.dataset.theme = theme;
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
